module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/fb-gray-e06d25f60200ce092ec77aa235778bd7.svg";